// Mermaid が出力した SVG 文字列の補正。DOM も他のファイルも使わない純粋関数だけを置き、
// node --test から直接確かめられるようにしている（mermaid-render.ts は i18n などを import するため直接は読めない）。

// Mermaid の Kanban は列に section-1, section-2, ... と番号順に class を付けるが、
// 色の CSS は section-10 までしか作らない（テーマの色数 THEME_COLOR_LIMIT=12 の制約）。
// 11列目以降は色が付かず、列の背景が SVG 既定の黒っぽい色になってしまうため、
// 描画後の SVG で番号を 1〜10 に循環させて付け直す。マインドマップは Mermaid 側で循環済み。
const KANBAN_SECTION_COLORS = 10;

export function fixKanbanSectionColors(svg: string) {
  if (!/aria-roledescription="kanban"/.test(svg)) {
    return svg;
  }
  return svg.replace(/(class="[^"]*\bsection-)(\d+)(?=[\s"])/g, (match, prefix, index) => {
    const n = Number(index);
    return n > KANBAN_SECTION_COLORS ? `${prefix}${((n - 1) % KANBAN_SECTION_COLORS) + 1}` : match;
  });
}
